import { Box, Text } from "@chakra-ui/react";

export default function FilterTags({ id, count, text, selected, method }) {
    const clickHandler = () => {
        method(id)
    }
    return (
        <Box
            borderRadius={selected ? '3xl' : 'none'}
            boxShadow={selected ? '0px 2px 6px rgba(0, 0, 0, 0.15)' : 'none'}
            bg={selected ? '#ffffff' : 'transparent'}
            onClick={clickHandler}
            py = {['5px','5px','5px','11px']}
            px={['10px','10px','10px','20px']}
            mr={['1','1','1rem','2rem']}
            cursor='pointer'
        >
            <Text
                style={{ fontFamily: 'Mulish, sans-serif' }}
                fontWeight='600'
                fontSize={['10px','12px','14px','18px']}
            >
                <b>{count}</b> {text}
            </Text>
        </Box>
    )
}